// extracted by mini-css-extract-plugin
module.exports =  {"primary":"ButtonPrimary-module__primary___mIQDM"};